import React from 'react';
import { View } from '@uncinc/react-drupal-core';

const AgendaOverview = () => {
  return (
    <View id="agenda" display="block_1" />
  );
};

export default AgendaOverview;
